<script setup lang="ts">
import { computed } from 'vue';
import type { Validation } from '@vuelidate/core';

const props = defineProps({
  passwordValue: {
    type: String,
    required: true,
  },
  passwordValidation: {
    type: Object as () => Validation | undefined, 
    required: true,
  },
  show: {
    type: Boolean,
    default: false,
  },
});


const emit = defineEmits(['close']);

const handleConcluirClick = () => {
  emit('close');
};

interface PasswordRule {
  key: string; 
  message: string;
}

const passwordRules = computed<PasswordRule[]>(() => [
  { key: 'minimumNumberOfCharacters', message: 'Mínimo 8 caracteres' },
  { key: 'hasNumeric', message: 'Ao menos 1 dígito numérico' },
  { key: 'hasLetter', message: 'Ao menos 1 letra' },
  { key: 'hasSpecialCharacter', message: 'Ao menos 1 caractere especial' },
]);

const isRuleValid = (ruleKey: string): boolean => {
  if (!props.passwordValidation) {
    return false;
  }
  if (!props.passwordValidation.$dirty) {
    return false;
  }

  const rulesRequiringContent = [
    'minimumNumberOfCharacters',
    'hasNumeric',
    'hasLetter',
    'hasSpecialCharacter',
  ];

  if (rulesRequiringContent.includes(ruleKey) && props.passwordValue === "") {
    return false; 
  }

  const hasErrorForThisRule = props.passwordValidation.$errors.some(
    (error) => error.$validator === ruleKey
  );
  return !hasErrorForThisRule;
};
</script>

<template>
  <div
    v-if="show"
    class="absolute z-50 w-6/7 max-w-md rounded-md border border-gray-100/10 bg-brand-card text-white backdrop-blur-sm px-3 mt-1 py-1 "
  >
    <ul class="space-y-1 text-sm">
      <li
        v-for="rule in passwordRules"
        :key="rule.key"
        class="flex items-center gap-1"
      >
        <Icon
          :name="isRuleValid(rule.key) ? 'fa6-solid:check' : 'fa6-solid:circle-xmark'"
          :class="isRuleValid(rule.key) ? 'text-green-500' : 'text-red-500'"
          class="h-3 w-3"
        />
        <span>{{ rule.message }}</span>
      </li>
    </ul>

    <button
      @click="handleConcluirClick"
      class=" py-1 bg-brand-primary w-full rounded-md mt-2 mb-2 text-sm font-semibold"
      variant="primary"
    >
      Concluir
    </button>
  </div>
</template>

